import { render, staticRenderFns } from "./WatchRecorded.vue?vue&type=template&id=72f50db4&scoped=true&"
import script from "./WatchRecorded.vue?vue&type=script&lang=ts&"
export * from "./WatchRecorded.vue?vue&type=script&lang=ts&"
import style0 from "./WatchRecorded.vue?vue&type=style&index=0&id=72f50db4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f50db4",
  null
  
)

export default component.exports